/* istanbul ignore file */
export { default as Tab } from './tab'
export { default as Tabs } from './tabs'
